import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const CambioLadaPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Cambio de LADA</PageTitle>
      <View />
    </>
  );
};

export { CambioLadaPage };
